import Store from '../../plugins/Store';
import httpRequest from '../../utils/httpRequest';
const SERVER_NAME = 'core';

// 角色管理
/**
 * 获取角色列表
 * @param {Object} data
 */
export function getRoleList(data = {}) {
    return httpRequest({
        url: '/role/query',
        serverName: SERVER_NAME,
        method: 'post',
        data,
    });
}

/**
 * 新增角色
 * @param {Object} data
 */
export function addRole(data = {}) {
    return httpRequest({
        url: '/role/save',
        serverName: SERVER_NAME,
        method: 'post',
        data,
    });
}

/**
 * 删除角色
 * @param {Object} data
 */
export function delRole(params) {
    return httpRequest({
        url: '/role/delete',
        serverName: SERVER_NAME,
        method: 'get',
        params,
    });
}
/**
 * 批量删除角色
 * @param {Object} data
 */
export function deleteByIdListRole(data) {
    return httpRequest({
        url: '/role/deleteByIdList',
        serverName: SERVER_NAME,
        method: 'post',
        data,
    });
}

/**
 * 获取权限
 * @param {Object} params
 */
export function getPermission(params) {
    return httpRequest({
        url: '/role/getPermission',
        serverName: SERVER_NAME,
        method: 'get',
        params,
    });
}

/**
 * 保存权限
 * @param {Object} data
 */
export function saveResource(data) {
    return httpRequest({
        url: '/role/saveResource',
        serverName: SERVER_NAME,
        method: 'post',
        data,
    });
}

/**
 * 获取配置项列表
 * @param {Object} data
 */
export function getConfigList(data = {}) {
    data.orgId = Store.getters['comon/userInfo'].orgId;
    return httpRequest({
        url: '/config/queryPage',
        serverName: SERVER_NAME,
        method: 'post',
        data,
    });
}
/**
 * 新增配置项
 * @param {Object} data
 */
export function addConfig(data = {}) {
    data.orgId = Store.getters['comon/userInfo'].orgId;
    return httpRequest({
        url: '/config/save',
        serverName: SERVER_NAME,
        method: 'post',
        data,
    });
}

/**
 * 修改配置项
 * @param {Object} data
 */
export function editConfig(data = {}) {
    // data.orgId = Store.getters['comon/userInfo'].orgId;
    return httpRequest({
        url: '/config/save',
        serverName: SERVER_NAME,
        method: 'post',
        data,
    });
}
